import React, { useRef, useEffect, useCallback } from 'react';
import { gsap } from '../../../../gsap';
import './Joints.scss';

function FutureJoints({ screenWidth }) {
  const futureJointsSection = useRef();
  const futureJointsCanvas = useRef();

  const futureJointsAnimation = useRef();
  const images = useRef([]);
  const ratio = useRef();

  const playOnScroll = useCallback(() => {
    ratio.current = screenWidth > 480 ? 1.2 : 1.6;
    images.current = [];
    // set canvas properties
    const canvas = futureJointsCanvas.current.getContext('2d');
    // Set the size of the canvas
    futureJointsCanvas.current.width =
      screenWidth > 480 ? Math.min(window.innerWidth / 2, 610) : window.innerWidth * 0.9;
    futureJointsCanvas.current.height = futureJointsCanvas.current.width * ratio.current;

    // Count the frames and set the path to the images
    const frameCount = 41;
    const currentFrame = (index, screenSize) =>
      `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/future/joints/${screenSize}/ACCESS_JOINT${(
        index + 1
      )
        .toString()
        .padStart(2, '0')}.png`;
    // Set start frame

    const joints = {
      frame: 0
    };

    // Go through frames from start to finish
    const jointAnim = gsap.timeline({
      scrollTrigger: {
        trigger: futureJointsSection.current,
        start: 'top top',
        endTrigger: futureJointsSection.current,
        end: 'bottom bottom',
        scrub: 1
      }
    });

    if (screenWidth < 481) {
      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i, 'mobile');
        images.current.push(img);
      }
    } else {
      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i, 'desktop');
        images.current.push(img);
      }
    }

    jointAnim.add('start').to(
      joints,
      {
        frame: frameCount - 1,
        snap: 'frame',
        duration: 5,
        ease: 'linear',
        onUpdate: render
      },
      'start'
    );

    images.current[0].onload = render;

    function render() {
      canvas.clearRect(0, 0, futureJointsCanvas.current.width, futureJointsCanvas.current.height);
      canvas.drawImage(
        images.current[joints.frame],
        0,
        0,
        futureJointsCanvas.current.width,
        futureJointsCanvas.current.height
      );
    }
  }, [screenWidth, images]);

  useEffect(() => {
    playOnScroll();
  }, [screenWidth, playOnScroll]);

  return (
    <section className="joints joints-future" ref={futureJointsSection}>
      <h3 className="joints__text__upper joints__text__upper-mobile">
        Instead of using balloon-like air pressure, one in-progress suit design uses tight fabric to
        apply the necessary pressure directly to the skin, which would greatly improve joint
        flexibility.
      </h3>

      <div
        className="joint__animation joint__animation-contemporary joint__animation-future"
        ref={futureJointsAnimation}
      >
        <canvas className="joints__animation__canvas" ref={futureJointsCanvas} />
      </div>
      <div className="joints__text joints__text-future">
        <h3 className="joints__text__upper joints__text__upper-desktop">
          Instead of using balloon-like air pressure, one in-progress suit design uses tight fabric
          to apply the necessary pressure directly to the skin, which would greatly improve joint
          flexibility.
        </h3>
        <h4 className="joints__text__title joints__text__title-future">Convolute Shoulder Joint</h4>
        <p className="joints__text__copy joints__text__copy-future">
          Morgan Stanley's Access I has a large shoulder aperture and a rolling convolute shoulder
          joint, allowing for a wide range of movement.
        </p>
      </div>
    </section>
  );
}

export default FutureJoints;
